// Protected download — once the password is accepted the page swaps to
// "starting…" and carries a short-lived signed link; follow it on our own, so
// the file starts without a second click. The link stays on screen as a
// fallback for browsers that block the automatic start.
export function initDownloadGate(): void {
  const link = document.querySelector<HTMLAnchorElement>('[data-dl-auto]');
  if (!link || !link.href) return;

  window.setTimeout(() => {
    window.location.href = link.href;
  }, 500);
}
